import { createSlice } from "@reduxjs/toolkit"
import moment from "moment"
import { setPosition } from "../floatingWindow/floatingWindowSlice"

const initialState = {
  twiDevice: null,
  twiCall: null,
  callStatus: "",
  isStarted: false,
  startDateTime: moment().format("YYYY-MM-DD HH:mm:ss"),
  toNumber: "",
  timer: 0,
  showTimer: null,
  navigateBack: "care call",
  showMarketingCall: false,
  position: { x: 500, y: 150 },
  marketingNotes: "",
  playingAudioIndex: null,
  // True while a fullscreen video consultation is on-screen — used to hide the
  // floating patient chat so it doesn't stick over the call.
  isVideoCallActive: false,
}

const callSlice = createSlice({
  name: "call",
  initialState,
  reducers: {
    setTwiDevice: (state, action) => {
      state.twiDevice = action.payload
    },
    setTwiCall: (state, action) => {
      state.twiCall = action.payload
    },
    setCallStatus: (state, action) => {
      state.callStatus = action.payload
    },
    setIsStarted: (state, action) => {
      state.isStarted = action.payload
    },
    setStartDateTime: (state, action) => {
      state.startDateTime = action.payload
    },
    setToNumber: (state, action) => {
      state.toNumber = action.payload
    },
    incrementTimer: (state, action) => {
      state.timer = state.timer + 1
    },
    setShowTimer: (state, action) => {
      if (!action.payload && state.showTimer) {
        clearInterval(state.showTimer)
        state.timer = 0
      }
      state.showTimer = action.payload
    },
    setNavigateBack: (state, action) => {
      state.navigateBack = action.payload
    },
    setShowMarketingCall: (state, action) => {
      state.showMarketingCall = action.payload
    },
    setDraggableComponentPosition: (state, action) => {
      state.position = action.payload
    },
    setMarketingNotes: (state, action) => {
      state.marketingNotes = action.payload
    },
    updatePlayingAudioIndex: (state, action) => {
      state.playingAudioIndex = action.payload
    },
    setIsVideoCallActive: (state, action) => {
      state.isVideoCallActive = action.payload
    },
  },
})

export const {
  setTwiDevice,
  setTwiCall,
  setCallStatus,
  setIsStarted,
  setStartDateTime,
  setToNumber,
  setShowTimer,
  incrementTimer,
  setNavigateBack,
  setShowMarketingCall,
  setDraggableComponentPosition,
  setMarketingNotes,
  updatePlayingAudioIndex,
  setIsVideoCallActive,
} = callSlice.actions
export default callSlice.reducer
